define("ember-cli-string-helpers/helpers/camelize", ["exports", "@ember/component/helper", "@ember/string", "ember-cli-string-helpers/-private/create-string-helper"], function (_exports, _helper, _string, _createStringHelper) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = _exports.camelize = void 0;
  const camelize = _exports.camelize = (0, _createStringHelper.default)(_string.camelize);
  var _default = _exports.default = (0, _helper.helper)(camelize);
});